import {
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  CustomInput,
  CustomPassword,
  UncontrolledTooltip,
  Alert,
  Button,
  Icon,
} from '@polichat/flamboyant';
import Animation from '../../../../common/animation';
import logoPagSeguro from '../../../../../assets/images/polipay/pagseguro.svg';

import PageMainHeader from '../../../../common/pages/PageMainHeader/PageMainHeader.component';
import PageMainBody from '../../../../common/pages/PageMainBody/PageMainBody.component';
import CancelButton from '../../../common/CancelButton';
import SaveButton from '../../../common/SaveButton';
import { Logo } from '../gateways.style';
import { useGlotaT } from '../../../../../hooks/useGlotaTranslation';

import usePagSeguroConfig from './usePagSeguroConfig';
import history from '../../../../../services/history';

function PagSeguroSettings() {
  const {
    isRequestLoading,
    isPageLoading,
    email,
    token,
    picture,
    customer_name,
    includeInstallment,
    maxInstallmentNoInterest,
    handleEmail,
    handleToken,
    handlePicture,
    handleCustomerName,
    handleIncludeInstallment,
    handleSubmit,
    handleMaxInstallmentsNoInterest,
  } = usePagSeguroConfig();

  // Traduções
  const integrationsText = useGlotaT('spa.shopping.integrations.title');
  const emailLabelText = useGlotaT('spa.shopping.integrations.pagseguro.emailLabel');
  const emailPlaceholderText = useGlotaT('spa.shopping.integrations.pagseguro.emailPlaceholder');
  const tokenLabelText = useGlotaT('spa.shopping.integrations.pagseguro.tokenLabel');
  const tokenPlaceholderText = useGlotaT('spa.shopping.integrations.pagseguro.tokenPlaceholder');
  const nameLabelText = useGlotaT('spa.shopping.integrations.pagseguro.nameLabel');
  const namePlaceholderText = useGlotaT('spa.shopping.integrations.pagseguro.namePlaceholder');
  const photoLinkLabelText = useGlotaT('spa.shopping.integrations.pagseguro.photoLinkLabel');
  const photoLinkPlaceholderText = useGlotaT('spa.shopping.integrations.pagseguro.photoLinkPlaceholder');
  const attentionText = useGlotaT('spa.shopping.integrations.pagseguro.attention');
  const installmentsWarningText = useGlotaT('spa.shopping.integrations.pagseguro.installmentsWarning');
  const installmentsDescriptionText = useGlotaT('spa.shopping.integrations.pagseguro.installmentsDescription');
  const feesAndRatesText = useGlotaT('spa.shopping.integrations.pagseguro.feesAndRates');
  const includeInstallmentsText = useGlotaT('spa.shopping.integrations.pagseguro.includeInstallments');
  const installmentsQuantityLabelText = useGlotaT('spa.shopping.integrations.pagseguro.installmentsQuantityLabel');
  const howManyInstallmentsText = useGlotaT('spa.shopping.integrations.pagseguro.howManyInstallments');
  const installmentsXText = useGlotaT('spa.shopping.integrations.pagseguro.installmentsX');
  const confirmText = useGlotaT('spa.common.confirm');

  return (
    <>
      <PageMainHeader title={integrationsText} icon="poli-icon pi-pay-fill" />
      <PageMainBody>
        <div>
          <Logo src={logoPagSeguro} alt="Pagseguro" width={30} />
          <span>
            <strong>PagSeguro</strong>
          </span>
        </div>
        <div>
          {isRequestLoading && <Animation icon="chat-loading" />}
        </div>
        {isPageLoading ? (
          <Animation icon="chat-loading" size="large" />
        ) : (
          <Form
            className="catalogForm"
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleSubmit();
            }}
          >
            <Row form>
              <Col lg={6}>
                <FormGroup>
                  <Label for="email">{emailLabelText}</Label>
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    value={email}
                    onChange={(e) => handleEmail(e.target.value)}
                    placeholder={emailPlaceholderText}
                    required
                  />
                </FormGroup>
              </Col>

              <Col lg={6}>
                <FormGroup>
                  <Label for="token">{tokenLabelText}</Label>

                  <CustomPassword
                    type="password"
                    name="token"
                    id="token"
                    value={token}
                    onChange={(e) => handleToken(e.target.value)}
                    placeholder={tokenPlaceholderText}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col lg={12}>
                <FormGroup>
                  <Label form="name">{nameLabelText}</Label>
                  <Input
                    id="name"
                    type="text"
                    name="name"
                    value={customer_name}
                    onChange={(e) => handleCustomerName(e.target.value)}
                    placeholder={namePlaceholderText}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col lg={12}>
                <FormGroup>
                  <Label form="picture" id="tooltip-label-picture">
                    {photoLinkLabelText}{' '}
                  </Label>
                  <UncontrolledTooltip
                    placement="right"
                    target={'tooltip-label-picture'}
                    autohide={false}
                  >
                    <div>
                      <h5 style={{ fontSize: '16px' }}>
                        Esse campo é opcional.
                      </h5>
                      <p style={{ textAlign: 'left' }}>
                        Insira o link da imagem hospedada. Verifique se o seu
                        link é com <strong>.jpg</strong> ou{' '}
                        <strong>.png</strong> no final, por exemplo: <br />
                        <strong>
                          https://img.techpowerup.org/200506/mesa-centro-supreme-preto.jpg
                        </strong>
                      </p>
                      <p style={{ textAlign: 'left' }}>
                        Sugestões de site para hospedar a imagem:
                        <br />*
                        <a
                          href="https://www.techpowerup.org/upload"
                          target="blank"
                        >
                          https://www.techpowerup.org/upload
                        </a>
                        <br />*
                        <a href="https://postimages.org/" target="blank">
                          https://postimages.org/
                        </a>
                      </p>
                    </div>
                  </UncontrolledTooltip>
                  <Input
                    id="picture"
                    type="url"
                    name="picture"
                    value={picture}
                    onChange={(e) => handlePicture(e.target.value)}
                    placeholder={photoLinkPlaceholderText}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col lg={12}>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    margin: 'auto',
                  }}
                >
                  <Alert color="primary" style={{ display: 'inline' }}>
                    <strong>{attentionText}: </strong> {installmentsWarningText}
                  </Alert>
                </div>
              </Col>
              <Col lg={8}>
                <p>
                  {installmentsDescriptionText}
                </p>
              </Col>
              <Col lg={4}>
                <Button
                  onClick={() =>
                    window.open(
                      'https://pagseguro.uol.com.br/para-seu-negocio/taxas-e-tarifas#selling-simulation'
                    )
                  }
                >
                  {feesAndRatesText}
                  <Icon
                    icon="pi-external-link-line"
                    size={20}
                    position={'relative'}
                    top={'0'}
                    right={'-5px'}
                  />
                </Button>
              </Col>
            </Row>
            <Row form style={{ marginBottom: '15px' }}>
              <Col>
                <FormGroup check inline>
                  <CustomInput
                    type="checkbox"
                    id="includeInstallment"
                    checked={includeInstallment}
                    onChange={(e) => handleIncludeInstallment(e.target.checked)}
                  />
                  <Label style={{ margin: '0' }}>{includeInstallmentsText}</Label>
                </FormGroup>
              </Col>
            </Row>
            {includeInstallment ? (
              <Row form>
                <Col lg={6}>
                  <FormGroup>
                  <Label for="email">{installmentsQuantityLabelText}</Label>
                  <CustomInput
                    type="select"
                    name="maxInstallmentNoInterest"
                    id="maxInstallmentNoInterest"
                    value={maxInstallmentNoInterest}
                    onChange={(e) =>
                      handleMaxInstallmentsNoInterest(e.target.value)
                    }
                    placeholder="Quantidade de parcelas sem Juros"
                    required
                  >
                    <optgroup label={howManyInstallmentsText}>
                        <option value={2}>2 {installmentsXText}</option>
                        <option value={3}>3 {installmentsXText}</option>
                        <option value={4}>4 {installmentsXText}</option>
                        <option value={5}>5 {installmentsXText}</option>
                        <option value={6}>6 {installmentsXText}</option>
                        <option value={7}>7 {installmentsXText}</option>
                        <option value={8}>8 {installmentsXText}</option>
                        <option value={9}>9 {installmentsXText}</option>
                        <option value={10}>10 {installmentsXText}</option>
                        <option value={11}>11 {installmentsXText}</option>
                        <option value={12}>12 {installmentsXText}</option>
                      </optgroup>
                    </CustomInput>
                  </FormGroup>
                </Col>
              </Row>
            ) : null}

            <Row form className="buttonsCenterContainer">
              <CancelButton
                onClick={(e) => {
                  e.preventDefault();
                  history.goBack({
                    formProductType: null,
                  });
                }}
              />

              <Button
                gradient="primary"
                width="quarter"
                title="confirmar"
                style={{
                  cursor: !email || !token ? 'not-allowed' : 'pointer',
                }}
                disabled={!email || !token ? true : false}
              >
                {confirmText}
              </Button>
            </Row>
          </Form>
        )}
      </PageMainBody>
    </>
  );
}

export default PagSeguroSettings;
